import type { Area } from '$lib/model/area';
import { DateTime } from 'luxon';
import { writable } from 'svelte/store';

export function loadBlockingPeriodsFromData(data: BlockingPeriodType[]) {
	blockingPeriods.set(
		data.map((bp) => ({
			...bp,
			date: DateTime.fromISO(bp.date as unknown as string),
			areaId: bp.areaId || undefined
		}))
	);
}

export type BlockingPeriodType = {
	id: string;
	start: number;
	end: number;
	date: DateTime;
	areaId: Area['id'] | undefined;
};

export const blockingPeriods = writable<BlockingPeriodType[]>([]);
